import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import {
  Invitation,
  InvitationAccessLevel,
  InvitationsQueryParams,
  InvitationStatusType,
} from '@vi-iot/client';

import { BulkSaveBuildingMangerInvitationsPayload } from '@store';

import { InvitationsActions } from './invitations.actions';
import { ActiveInvitationsFilterType } from './invitations.model';
import { InvitationsSelectors } from './invitations.selectors';

@Injectable({ providedIn: 'root' })
export class InvitationsStore {
  state$ = this.store.select(InvitationsSelectors.getState());
  acceptedDate$ = this.store.select(InvitationsSelectors.getAcceptedDateInvitation());
  invitationsLoaded$ = this.store.select(InvitationsSelectors.getAreInvitationsLoaded());
  incomingCount$ = this.store.select(InvitationsSelectors.getIncomingCount());
  pendingTransferInstallationInvitations$ = this.store.select(
    InvitationsSelectors.getPendingTransferInstallationInvitations()
  );
  incomingInvitations$ = this.store.select(InvitationsSelectors.incomingInvitations);

  constructor(private store: Store) {}

  bulkListInvitations(installationId?: string | number): void {
    this.store.dispatch(InvitationsActions.bulkListInvitations({ installationId }));
  }

  bulkSaveBuildingManagerInvitations(
    invitationsToSave: BulkSaveBuildingMangerInvitationsPayload
  ): void {
    this.store.dispatch(
      InvitationsActions.bulkSaveBuildingMangerInvitations({ invitationsToSave })
    );
  }

  listInstallationInvitations(installationId: string | number): void {
    this.store.dispatch(InvitationsActions.listInstallationInvitations({ installationId }));
  }

  getUserInvitations(params: InvitationsQueryParams): void {
    this.store.dispatch(InvitationsActions.getUserInvitations({ params }));
  }

  getPendingInvitationsCount(): void {
    this.store.dispatch(InvitationsActions.getIncomingInvitationsCount());
  }

  listPendingTransferInstallationInvitations(installationId: string | number): void {
    this.store.dispatch(
      InvitationsActions.listPendingTransferInstallationInvitations({ installationId })
    );
  }

  updateInvitation(token: string, status: InvitationStatusType, ownerName?: string): void {
    this.store.dispatch(
      InvitationsActions.updateInvitation({ token, request: { status }, ownerName })
    );
  }

  updateCommercialInvitation(
    token: string,
    status: InvitationStatusType,
    ownerName?: string
  ): void {
    this.store.dispatch(
      InvitationsActions.updateCommercialInvitation.attempt({
        token,
        request: { status },
        ownerName,
      })
    );
  }

  filterInvitations(activeFilter: ActiveInvitationsFilterType): void {
    this.store.dispatch(InvitationsActions.filterInvitations({ activeFilter }));
  }

  getInstallationRoleManagementInvitations(
    installationId: string | number
  ): Observable<Invitation[]> {
    return this.store.select(
      InvitationsSelectors.getInstallationRoleManagementInvitations(installationId)
    );
  }

  createInvitation(
    installationId: number,
    inviteeEmail: string,
    accessLevel: InvitationAccessLevel
  ): void {
    this.store.dispatch(
      InvitationsActions.createInvitation({ installationId, inviteeEmail, accessLevel })
    );
  }

  getCommercialInvitationStatus(token: string): Observable<InvitationStatusType> {
    return this.store.select(InvitationsSelectors.getCommercialInvitationStatus(token));
  }
}
